import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
function gpt4_0(imagePath, positive, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      108: {
        inputs: {
          noise_seed: seed
        },
        class_type: 'RandomNoise',
        _meta: {
          title: 'RandomNoise'
        }
      },
      109: {
        inputs: {
          scheduler: 'simple',
          steps: 20,
          denoise: 1,
          model: [
            '138',
            0
          ]
        },
        class_type: 'BasicScheduler',
        _meta: {
          title: 'BasicScheduler'
        }
      },
      121: {
        inputs: {
          clip_name1: 't5xxl_fp8_e4m3fn.safetensors',
          clip_name2: 'clip_l.safetensors',
          type: 'flux',
          device: 'default'
        },
        class_type: 'DualCLIPLoader',
        _meta: {
          title: 'DualCLIPLoader'
        }
      },
      122: {
        inputs: {
          text: [
            '162',
            0
          ],
          clip: [
            '121',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Positive Prompt)'
        }
      },
      124: {
        inputs: {
          guidance: 2.5,
          conditioning: [
            '122',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      125: {
        inputs: {
          unet_name: 'flux1-kontext-dev.safetensors',
          weight_dtype: 'fp8_e4m3fn'
        },
        class_type: 'UNETLoader',
        _meta: {
          title: 'Load Diffusion Model'
        }
      },
      129: {
        inputs: {
          conditioning: [
            '124',
            0
          ],
          latent: [
            '130',
            0
          ]
        },
        class_type: 'ReferenceLatent',
        _meta: {
          title: 'ReferenceLatent'
        }
      },
      130: {
        inputs: {
          pixels: [
            '147',
            0
          ],
          vae: [
            '131',
            0
          ]
        },
        class_type: 'VAEEncode',
        _meta: {
          title: 'VAE Encode'
        }
      },
      131: {
        inputs: {
          vae_name: 'FLUX.1-vae.sft'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      133: {
        inputs: {
          sampler_name: 'euler'
        },
        class_type: 'KSamplerSelect',
        _meta: {
          title: 'KSamplerSelect'
        }
      },
      134: {
        inputs: {
          noise: [
            '108',
            0
          ],
          guider: [
            '135',
            0
          ],
          sampler: [
            '133',
            0
          ],
          sigmas: [
            '109',
            0
          ],
          latent_image: [
            '142',
            0
          ]
        },
        class_type: 'SamplerCustomAdvanced',
        _meta: {
          title: 'SamplerCustomAdvanced'
        }
      },
      135: {
        inputs: {
          model: [
            '138',
            0
          ],
          conditioning: [
            '129',
            0
          ]
        },
        class_type: 'BasicGuider',
        _meta: {
          title: 'BasicGuider'
        }
      },
      136: {
        inputs: {
          samples: [
            '134',
            0
          ],
          vae: [
            '131',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      138: {
        inputs: {
          max_shift: 1.15,
          base_shift: 0.5,
          width: 1024,
          height: 1024,
          model: [
            '125',
            0
          ]
        },
        class_type: 'ModelSamplingFlux',
        _meta: {
          title: 'ModelSamplingFlux'
        }
      },
      141: {
        inputs: {
          megapixel: '1.0',
          aspect_ratio: '3:4 (Golden Ratio)',
          divisible_by: '64',
          custom_ratio: false,
          custom_aspect_ratio: '1:1'
        },
        class_type: 'FluxResolutionNode',
        _meta: {
          title: 'Flux Resolution Calc'
        }
      },
      142: {
        inputs: {
          width: [
            '144',
            0
          ],
          height: [
            '146',
            0
          ],
          batch_size: 1
        },
        class_type: 'EmptyLatentImage',
        _meta: {
          title: 'Empty Latent Image'
        }
      },
      143: {
        inputs: {
          expression: 'a/64',
          a: [
            '141',
            0
          ]
        },
        class_type: 'MathExpression|pysssss',
        _meta: {
          title: 'Math Expression 🐍'
        }
      },
      144: {
        inputs: {
          expression: 'a*64',
          a: [
            '143',
            0
          ]
        },
        class_type: 'MathExpression|pysssss',
        _meta: {
          title: 'Math Expression 🐍'
        }
      },
      145: {
        inputs: {
          expression: 'a/64',
          a: [
            '141',
            1
          ]
        },
        class_type: 'MathExpression|pysssss',
        _meta: {
          title: 'Math Expression 🐍'
        }
      },
      146: {
        inputs: {
          expression: 'a*64',
          a: [
            '145',
            0
          ]
        },
        class_type: 'MathExpression|pysssss',
        _meta: {
          title: 'Math Expression 🐍'
        }
      },
      147: {
        inputs: {
          width: 1024,
          height: 1024,
          interpolation: 'nearest',
          method: 'keep proportion',
          condition: 'always',
          multiple_of: 0,
          image: [
            '164',
            0
          ]
        },
        class_type: 'ImageResize+',
        _meta: {
          title: '🔧 Image Resize'
        }
      },
      148: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      161: {
        inputs: {
          text: positive
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      162: {
        inputs: {
          boolean: true,
          on_true: [
            '148',
            0
          ],
          on_false: [
            '161',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      164: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: 'AC_从URL加载图像'
        }
      },
      165: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '136',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 165// prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  gpt4_0
}
